import { type SupportedLocales } from "@app/shared/utils/locales";
import { Button } from "@design-system/Inputs/Button";
import { Chip } from "@design-system/Inputs/Chip";
import { Dropdown } from "@design-system/Inputs/UniversalDropdown";
import { Box } from "@design-system/Layout/Box";
import { useMemo, type FC } from "react";
import { useSupplierQuestionsGroupSelectTranslations } from "./i18n";

export const QuestionGroupSelectTrigger: FC<{
    selectedGroup:
        | {
              id: string;
              name: {
                  en?: string | null;
                  fr?: string | null;
              };
          }
        | undefined;
    locale: SupportedLocales;
}> = ({ selectedGroup, locale }) => {
    const { t, keys } = useSupplierQuestionsGroupSelectTranslations();

    const displayedName = useMemo(() => {
        if (selectedGroup) {
            return selectedGroup.name?.[locale] ?? t(keys.group_not_translated);
        }
        return undefined;
    }, [selectedGroup, locale, t, keys]);

    return displayedName ? (
        <Dropdown.Trigger asChild>
            <Chip interactive size="sm">
                <Chip.Value>{displayedName}</Chip.Value>
            </Chip>
        </Dropdown.Trigger>
    ) : (
        <Dropdown.Trigger asChild>
            <Box p="0.5">
                <Button variant="tonal" size="xs" className="h-6">
                    <Button.Icon name="plus" size="xs" />
                </Button>
            </Box>
        </Dropdown.Trigger>
    );
};
